import * as React from 'react';
import { Form, Input, Button, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface Props {
    fields: any[];
    onChange: (fields: any[]) => void;
    onRegister: (d: any) => void;
    loading: boolean;
}

export default function SignupForm({
                                       fields,
                                       onChange,
                                       onRegister,
                                       loading,
                                   }: Props) {
    const { t } = useTranslation();
    const [form] = Form.useForm();


    function handleSubmit(values: any) {
        if (onRegister) {
            onRegister(values);
        }
    }

    return (
        <Form
            size="large"
            form={form}
            fields={fields}
            onFieldsChange={(changedFields, allFields) => {
                onChange(allFields);
            }}
            onFinish={handleSubmit}
            layout="vertical"
            requiredMark={false}
        >
            <div className='row'>
                <div className='col-md-6'>
                    <Form.Item
                        label={t('register.name.label')}
                        name="name"
                        rules={[
                            { required: true, message: t('register.name.required') },
                        ]}
                    >
                        <Input className='br-5px'/>
                    </Form.Item>
                </div>
                <div className='col-md-6'>
                    <Form.Item
                        label={t('register.email.label')}
                        name="email"
                        rules={[
                            {
                                required: true, type: 'email',
                                message: t('register.email.required'),
                            },
                        ]}
                    >
                        <Input className='br-5px' type={'email'}/>
                    </Form.Item>
                </div>
                <div className='col-md-6'>
                    <Form.Item
                        label={t('register.phone.label')}
                        name="phone"
                        rules={[
                            {
                                required: true,
                                message: t('register.phone.required'),
                            },
                        ]}
                    >
                        <Input className='br-5px'/>
                    </Form.Item>
                </div>
                <div className='col-md-6'>
                    <Form.Item
                        label={t('register.gender.label')}
                        name="gender"
                        rules={[
                            {
                                required: true,
                                message: t('register.gender.required'),
                            },
                        ]}
                    >
                        <Select className='br-5px' placeholder={t('genDict.select')}>
                            {
                                ['male', 'female'].map((a) => {
                                    return <Select.Option value={a}>
                                        {
                                            t('genDict.' + a)
                                        }
                                    </Select.Option>;
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>
                <div className='col-md-6'>
                    <div className="__password">
                        <Form.Item
                            label={t('register.password.label')}
                            name="password"
                            rules={[
                                { required: true, message: t('register.password.required') },
                            ]}
                        >
                            <Input.Password className='br-5px'
                                onChange={() => {
                                    form.validateFields(['password_confirmation']);
                                }}
                                type="password"
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className="__password">
                        <Form.Item
                            label={t('register.password_confirmation.label')}
                            name="password_confirmation"
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject(
                                                t('register.password.required'),
                                            );
                                        }
                                        if (value && getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            t('register.password.unmatched'),
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password className='br-5px'
                                type="password"
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className='col-md-12'>
                    <Form.Item>
                        <Button
                            htmlType="submit"
                            loading={loading}
                            shape="round"
                            size={'large'}
                            className="submit btn btn-blue w-100"
                        >
                            {t('register.connect')}
                        </Button>
                    </Form.Item>
                </div>
            </div>
        </Form>
    );
}
